import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackPressedPurchaseButton = () => {
  const { track } = useAnalyticsUtilities();

  const trackPressedPurchaseButton = useCallback(() => {
    track(`Pressed purchase button in checkout`);
  }, [track]);

  return { trackPressedPurchaseButton };
};
